export type WavyLineProps = {
  className?: string;
};

export const WavyLine: React.VFC<WavyLineProps> = ({ className }) => (
  <svg viewBox="0 0 1440 90" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} preserveAspectRatio="none">
    <path
      d="M-16 88.3249L51.0417 73.0391C118.083 57.7533 252.167 27.1817 386.25 11.8959C520.333 -3.38988 654.417 -3.38988 788.5 16.9912C922.583 37.3723 1056.67 78.1344 1190.75 83.2297C1324.83 88.3249 1458.92 57.7533 1525.96 42.4675L1593 27.1817"
      stroke="#8750D7"
      stroke-width="2"
    />
  </svg>
);
